<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content class="wemail-sites-overview">
        <h2>
          <a-breadcrumb>
            <a-breadcrumb-item>
              <router-link tag="a" :to="{ name: 'eventlogs.all' }">Logs</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{ this.$route.meta.title }}</a-breadcrumb-item>
          </a-breadcrumb>
        </h2>
        <div class="wemail-tabs-wrap">
          <div class="wemail-site-nav-wrap">
            <router-link tag="a-button" :to="{name:'eventlogs.all'}" active-class="ant-menu-item-selected">All</router-link>
            <router-link tag="a-button" :to="{name:'eventlogs.success'}" active-class="ant-menu-item-selected">Success</router-link>
            <router-link tag="a-button" :to="{name:'eventlogs.failed'}" active-class="ant-menu-item-selected">Failed</router-link>
          </div>
          <div class="wemail-overview-content">
            <router-view></router-view>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
export default {
  components: {
    Sidebar
  },
  data() {
    return {
      datacollection: null
    };
  },
  methods: {}
};
</script>
<style >
[ant-click-animating-without-extra-node]:after {
  animation: 0s !important;
}
.wemail-sites-overview {
  margin: 30px;
  min-height: 100vh;
}
.wemail-overview-content {
  padding: 15px;
  background: #fafafa;
}
.wemail-overview-content table {
  border: 1px solid #e8e8e8;
}
.wemail-tabs-wrap {
  border: 1px solid #d9d9d9;
}
.wemail-site-nav-wrap {
  display: flex;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d9d9d9;
  padding: 10px 10px 0;
}
.wemail-site-nav-wrap button {
  border-radius: 0;
  border-color: transparent;
  height: auto;
  padding: 12px 25px;
  box-shadow: none;
  margin-right: 5px;
}
.wemail-site-nav-wrap button.ant-menu-item-selected {
  background: #fafafa;
  border-color: #d9d9d9;
  position: relative;
  border-radius: 3px 3px 0 0;
}
.wemail-site-nav-wrap button.ant-menu-item-selected:after {
  content: "";
  position: absolute;
  width: 100%;
  z-index: 999;
  left: 0;
  top: 100%;
  height: 2px;
  opacity: 1;
  background: #fafafa;
}
.wemail-site-nav-wrap button:hover {
  border-color: #d9d9d9;
  border-bottom-color: #1890ff;
}
.wemail-site-nav-wrap button:not(:last-child) {
  /* border-right: 0; */
}
.wemail-site-nav-wrap button:first-child {
  /* border-radius: 3px 0 0 3px; */
}
.wemail-site-nav-wrap button:last-child {
  /* border-radius: 0 3px 3px 0; */
}
.ant-breadcrumb-link {
  font-size: 1.4em;
}
</style>
